
(() => {
  const TEA_ID = 52991011324216;
  const SPOON_ID = 53114100810040;
  const CART_ROOT = window.Shopify?.routes?.root || '/';

  let syncing = false;
  let queued = false;

  async function syncGift() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;

    try {
      const cart = await fetch(`${CART_ROOT}cart.js`).then(r => r.json());

      const teaCount = cart.items
        .filter(item => item.variant_id === TEA_ID)
        .reduce((total, item) => total + item.quantity, 0);

      const spoons = cart.items.filter(item => item.variant_id === SPOON_ID);
      const spoonCount = spoons.reduce((total, item) => total + item.quantity, 0);

      if (teaCount >= 2 && spoonCount === 0) {
        await fetch(`${CART_ROOT}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: SPOON_ID, quantity: 1 }]
          })
        });
      } else if (teaCount < 2 && spoonCount > 0) {
        await fetch(`${CART_ROOT}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: { [SPOON_ID]: 0 }
          })
        });
      } else if (teaCount >= 2 && spoonCount > 1) {
        await fetch(`${CART_ROOT}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: { [SPOON_ID]: 1 }
          })
        });
      } else {
        return;
      }

      // Refresh the page to display the updated cart.
      window.location.reload();
    } catch (error) {
      console.error('Magic free gift error:', error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        syncGift();
      }
    }
  }

  // Check whenever the customer returns to or opens the cart.
  document.addEventListener('DOMContentLoaded', syncGift);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncGift();
  });

  // Watch for cart-changing requests made by the theme.
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = String(args[0]?.url || args[0] || '');

    if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) {
      setTimeout(syncGift, 200);
    }

    return response;
  };
})();
